<ul ngbNav #tabs="ngbNav" class="nav-tabs" [(activeId)]="activeId" (navChange)="tabChange($event)">
  <li [ngbNavItem]="infoTab" title="{{ infoTitle }}">
    <a ngbNavLink>{{infoTitle}}</a>
    <ng-template ngbNavContent>
      <img src="{{ productImagePath }}" alt="{{ productName }}" class="productImage" />
      <markdown [data]="infoText"></markdown>
    </ng-template>
  </li>
  <li [ngbNavItem]="imprintTab">
    <a ngbNavLink>{{imprintTitle}}</a>
    <ng-template ngbNavContent>
      <markdown [data]="imprintText"></markdown>
    </ng-template>
  </li>
  <li [ngbNavItem]="termsOfUseTab" title="{{ termsOfUseTitle }}">
    <a ngbNavLink>{{termsOfUseTitle}}</a>
    <ng-template ngbNavContent>
      <div class="mt-4 mb-4" *ngIf="showAcceptedProductInfoCheckbox || showAcceptedCommonInfoCheckbox">
        <div class="consent-to-information-transfer-title">{{ 'common.legal.consentToInformationTransferTitle'|
          translate}}
        </div>
        <hr class="my-2" />
        <div class="d-flex flex-row ">
          <div class="p-2" *ngIf="showAcceptedProductInfoCheckbox">
            <input type="checkbox" [checked]="hasAcceptedProductInfo" #hasAcceptedProductInfoCheckbox
              (change)="hasAcceptedProductInfoValueChange(hasAcceptedProductInfoCheckbox.checked)" kendoCheckBox />
          </div>
          <div class="p-2" *ngIf="showAcceptedProductInfoCheckbox">
            <label> {{ 'common.legal.hasAcceptedProductInfo'| translate }} </label>
          </div>
        </div>
        <div class="d-flex flex-row">
          <div class="p-2" *ngIf="showAcceptedCommonInfoCheckbox">
            <input type="checkbox" [checked]="hasAcceptedCommonInfo" #hasAcceptedCommonInfoCheckbox
              (change)="hasAcceptedCommonInfoValueChange(hasAcceptedCommonInfoCheckbox.checked)" kendoCheckBox />
          </div>
          <div class="p-2" *ngIf="showAcceptedCommonInfoCheckbox">
            <label> {{ 'common.legal.hasAcceptedCommonInfo' | translate }} </label>
          </div>
        </div>
      </div>
      <markdown [data]="termsOfUseText"></markdown>
    </ng-template>
  </li>
  <li [ngbNavItem]="privacyTab" title="{{ privacyTitle }}">
    <a ngbNavLink>{{privacyTitle}}</a>
    <ng-template ngbNavContent>
      <markdown [data]="privacyText"></markdown>
    </ng-template>
  </li>
</ul>
<div [ngbNavOutlet]="tabs"></div>